<template>
  <div v-loading="loading">
    <el-select class="m-b-10" v-model="year" placeholder="请选择年份" @change="getData">
      <el-option v-for="option in yearOptions" :label="option.name" :value="option.id"></el-option>
    </el-select>
    <div class="tx-c m-b-10">工程质安数据统计</div>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="start"
        label="开工项目"
        width="600">
      </el-table-column>
      <el-table-column
        prop="end"
        label="竣工项目">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  export default {
    iden: 'projectQuality',
    data() {
      return {
        tableData: [],
        year: null,
        yearOptions: [],
        loading: false
      }
    },
    created() {
      let thisYear = 1900 + (new Date()).getYear()
      for (let i = thisYear; i >= 1970; i--) {
        this.yearOptions.push({
          id: i,
          name: `${i}年`
        })
      }
      this.year = thisYear
      this.getData()
    },
    methods: {
      async getData() {
        let postData = {
          params: {
            year: this.year
          }
        }
        this.loading = true
        let res = await this.apiGet('statistic/project/get_project_count', postData)
        let data = this.promiseHandler(data, res)
        this.tableData = data
        this.loading = false
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// projectQuality.vue?bcbf6552